import {Component, OnInit} from '@angular/core';
import {OrderService} from '../../services/OrderService';
import {AppUser} from '../../../framework/model/core/appuser/appuser';
import {Events} from "../../../framework/providers/events";
import {AppDataService} from "../../services/AppDataService";


@Component({
    selector: 'app-favorites',
    templateUrl: './favorites.page.html',
    styleUrls: ['./favorites.page.scss'],
})
export class FavoritesPage implements OnInit {
    public appuser: AppUser;
    public prefix = 'favorites_list';

    public itemsarr;

    constructor(public orderService: OrderService, public events:Events, public appdataService:AppDataService) {
        this.appuser = this.orderService.getAppUser();
        this.itemsarr = this.appdataService.getPricesListKey('itemToUser');
        console.log(this.itemsarr)
    }

    ngOnInit() {
        // this.events.subscribe('favorites_updated', ()=>{
        //     this.events.publish(this.prefix+'_updateItemsFilter');
        // })
    }

    ngOnDestroy()
    {
        // this.events.unsubscribe('favorites_updated');
    }

}
